module.exports = __webpack_public_path__ + "static/img/new_pl3.205a9ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_pl3.png
// module id = 9DH3
// module chunks = 101